import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  user: {
    id: '',
    userAlias: '',
    username: '',
    zone: [
      {
        code: '',
        desc: '',
        location: '',
        type: {
          key: '',
          value: '',
        },
      },
    ],
    name: '',
    surname: '',
    email: '',
    season: [
      {
        season: '',
        descEng: '',
        descIt: '',
        timestamp: '',
      },
    ],
    permissions: [''],
  },
  zones: [
    {
      code: '',
      desc: '',
      location: '',
      type: {
        key: '',
        value: '',
      },
    },
  ],
  zonesWithSpecial: [],
  isUserDistributor: false,
};

export const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.user = action.payload;
    },
    setUserZones(state, action) {
      state.zones = action.payload;
    },
    setIsDistributor(state) {
      state.isUserDistributor = state.user.permissions.includes('DISTRIBUTOR');
    },
    logout: () => {},
  },
});

export const getState = (rootState: RootState) => rootState.userData;
export const getUserZones = (rootState: RootState) => rootState.userData.zones;
export const getUserZonesWithSpecial = (rootState: RootState) => rootState.userData.user.zone;
export const getUserPermissions = (rootState: RootState) =>
  rootState.userData.user.permissions;

export const { setCurrentUser, logout, setUserZones, setIsDistributor } =
  userDataSlice.actions;
